import React, { ChangeEvent, memo } from 'react';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';
import { IconBackgroundType } from '../../enums/IconBackgroundType';

const BackgroundTypeControls = () => {

    const dispatch = useAppDispatch();
    const backgroundType = useAppSelector(store => store.form.backgroundType);

    const handleBackgroundTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {

        const updatedValue = Number(evt.target.value);

        dispatch(
            formActions.main({
                backgroundType: updatedValue,
            })
        );
    };

    return (
        <div className="animation-radio-buttons px-4 py-3 border border-gray-700 rounded">
            <div className="mb-2">Background Type</div>
            {
                <div className="flex flex-wrap items-center text-sm xl:grid xl: grid-cols-2">

                    <label className="flex items-center cursor-pointer" title="Circle">
                        <input
                            type="radio"
                            name="background-type"
                            value={ IconBackgroundType.Circle }
                            className="hidden"
                            checked={ backgroundType === IconBackgroundType.Circle }
                            onChange={ handleBackgroundTypeChange }
                        />
                        <div className="px-2 md:px-4 py-1">
                            Circle
                        </div>
                    </label>

                    <label className="flex items-center cursor-pointer" title="Rectangle">
                        <input
                            type="radio"
                            name="background-type"
                            value={ IconBackgroundType.Rectangle }
                            className="hidden"
                            checked={ backgroundType === IconBackgroundType.Rectangle }
                            onChange={ handleBackgroundTypeChange }
                        />
                        <div className="px-2 md:px-4 py-1">
                            Rectangle
                        </div>
                    </label>

                    <label className="flex items-center cursor-pointer" title="Rounded Rectangle">
                        <input
                            type="radio"
                            name="background-type"
                            value={ IconBackgroundType.RoundedRectangle }
                            className="hidden"
                            checked={ backgroundType === IconBackgroundType.RoundedRectangle }
                            onChange={ handleBackgroundTypeChange }
                        />
                        <div className="px-2 md:px-4 py-1">
                            Rounded
                        </div>
                    </label>

                    <label className="flex items-center cursor-pointer" title="Transparent">
                        <input
                            type="radio"
                            name="background-type"
                            value={ IconBackgroundType.Transparent }
                            className="hidden"
                            checked={ backgroundType === IconBackgroundType.Transparent }
                            onChange={ handleBackgroundTypeChange }
                        />
                        <div className="px-2 md:px-4 py-1">
                            Transparent
                        </div>
                    </label>


                </div>
            }
        </div>
    )
};

export default memo(BackgroundTypeControls);